module.exports = __webpack_public_path__ + "img/image_2.0d68082e.jpg";